import { ToggleButton, ToggleButtonItem, Slider } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import NumberBox from 'devextreme-react/number-box';
import { MobileDrawItem } from '../../../../../types/MobileDrawItem';

interface MobileDrawAmountParameters {
    mobileDrawItem: MobileDrawItem;
    set_mobileBorrowerRequest: (drawItemId: number, borrowerRequest: number) => void;
    drawAmountCalculationMetric: string;
    set_drawAmountCalculationMetric: (calculationMetric: string) => void;
}

export const MobileDrawAmount: React.FC<MobileDrawAmountParameters> = ({
    mobileDrawItem,
    set_mobileBorrowerRequest,
    drawAmountCalculationMetric,
    set_drawAmountCalculationMetric,
}) => {
    const dollarPercentButtonItems: ToggleButtonItem[] = [
        {
            id: 'dollar',
            text: '$',
            hint: 'Click $',
            disabled: mobileDrawItem.availableAmount == 0,
        },
        {
            id: 'percent',
            text: '%',
            hint: 'Click %',
            disabled: mobileDrawItem.availableAmount == 0,
        },
    ];

    const toggleButtonItemClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        set_drawAmountCalculationMetric(e.itemData.id);
    };

    return (
        <div className='mobileDrawAmount'>
            <div className='toggleButton'>
                <ToggleButton
                    id='toggleButtonDemoPercentDollar'
                    items={dollarPercentButtonItems}
                    selectedItems={[drawAmountCalculationMetric]}
                    selectionMode='single'
                    stylingMode='outlined'
                    onItemClick={toggleButtonItemClick}
                    width='80px'
                />
            </div>
            <div className={`dollarAmount ${drawAmountCalculationMetric == 'dollar' ? 'visible' : 'hidden'}`}>
                <NumberBox
                    format='$ #,##0.00'
                    defaultValue={mobileDrawItem.borrowerRequest}
                    value={mobileDrawItem.borrowerRequest}
                    min={0}
                    max={mobileDrawItem.availableAmount}
                    onValueChange={(value) => set_mobileBorrowerRequest(mobileDrawItem.id, value)}
                    valueChangeEvent='input'
                />
            </div>
            <div className={`percentAmount ${drawAmountCalculationMetric == 'percent' ? 'visible' : 'hidden'}`}>
                <Slider
                    maxAmount={mobileDrawItem.budgetAmount}
                    value={mobileDrawItem.borrowerRequest}
                    reservedAmount={mobileDrawItem.budgetAmount - mobileDrawItem.availableAmount}
                    onValueChanged={(value) => {
                        return set_mobileBorrowerRequest(mobileDrawItem.id, value);
                    }}
                    noValueMessage='No Amount Available to Draw'
                />
            </div>
        </div>
    );
};
